import React, { useState, useEffect, useRef } from 'react';
import './Style/common.css';
import './Style/header.css';
import './Style/AllPurchases.css';
import './Style/trophy_club.css';
import "./Style/SkillBuildingGames.css";
import $ from 'jquery';
import Header from '../../Common/Header';
import Loading from '../../Common/Loading';
import Section from '../../Common/Section';
import CryptoJS from 'crypto-js';

const SECRET_ENCRYPTION_KEY = "6GJZIa6J7NZzTdzf4K7Em6y6XiqwT09wqkKkNHaAvjE=";

function decrypt(encryptedBase64: string) {
  try {
    const key = CryptoJS.enc.Base64.parse(SECRET_ENCRYPTION_KEY);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return {};
  }
}

const AllPurchases: React.FC = () => {
  const [, setUserName] = useState<string>("");
  const [, setImageSrc] = useState('');
  const [loading, setLoading] = useState<boolean>(true);
  const [purchases, setPurchases] = useState<any[]>([]);
        const [showBackToTop, setShowBackToTop] = useState(false);
    const [showBackToBottom, setShowBackToBottom] = useState(true);
    const scrollContainerRef = useRef<HTMLElement | null>(null);

  // const apiUrl = process.env.REACT_APP_DOCUMENT_LINK || 'http://127.0.0.1:8000/';
  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

     const findScrollContainer = (): HTMLElement => {
      const candidates: (HTMLElement | null)[] = [
        (document.scrollingElement as HTMLElement) || null,
        document.getElementById("contents_math"),
        document.getElementById("main_top_container"),
        document.getElementById("contents_english"),
        document.getElementById("contents_physics"),
        document.getElementById("contents_chemistry"),
        document.getElementById("contents_biology"),
        document.body,
        document.documentElement,
      ];

      for (const el of candidates) {
        if (!el) continue;
        try {
          const style = window.getComputedStyle(el);
          const overflowY = style.overflowY;
          if (el.scrollHeight > el.clientHeight && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay" || overflowY === "visible")) {
            return el;
          }
        } catch (e) {
        }
      }
      return (document.scrollingElement as HTMLElement) || document.documentElement;
    };

    // detect and store the scroll container so click handlers can scroll the same element
    scrollContainerRef.current = findScrollContainer();
    const registeredContainer = scrollContainerRef.current;

    const handleScroll = () => {
      const el = (scrollContainerRef.current || registeredContainer || (document.scrollingElement as HTMLElement) || document.documentElement) as HTMLElement;
      const scrollTop = el.scrollTop;
      const innerH = el.clientHeight || window.innerHeight;
      const scrollHeight = el.scrollHeight;

      const scrollable = Math.max(0, scrollHeight - innerH);
      const TOL = 6;
      const atTop = scrollTop <= TOL;
      const atBottom = scrollTop >= Math.max(0, scrollable - TOL);
      const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

      if (atTop) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
        return;
      }

      if (atBottom) {
        setShowBackToTop(true);
        setShowBackToBottom(false);
        return;
      }

      if (ratio < 0.5) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
      } else {
        setShowBackToTop(true);
        setShowBackToBottom(false);
      }
    };
     try {
      if (registeredContainer) {
        registeredContainer.addEventListener("scroll", handleScroll, { passive: true });
      } else {
        window.addEventListener("scroll", handleScroll, { passive: true });
      }
    } catch (e) {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }

    // run once to set initial state
    setTimeout(handleScroll, 0);
  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${apiUrl}AllPurchases/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Login: sessionStorage.getItem("Login"),
            FamilyCode: sessionStorage.getItem("FamilyCode"),
            SchoolCode: sessionStorage.getItem("SchoolCode"),
          }),
        });

        if (!response.ok) throw new Error(`API failed: ${response.status}`);

        const payload = await response.json();
        const decryptedData = Array.isArray(payload)
          ? payload
          : decrypt(payload?.data);
        const purchaseList = Array.isArray(decryptedData)
          ? decryptedData
          : Array.isArray(decryptedData?.purchases)
            ? decryptedData.purchases
            : [];

        if (purchaseList.length > 0) {
          setPurchases(purchaseList);
        } else {
          setPurchases([]);
        }
      } catch (err) {
        // console.error("Error fetching purchases:", err);
        setPurchases([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();

    const handleClick = (e: any) => {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "slow");
    };
    $(".AllPurchases").on("click", handleClick);

    const UserName = sessionStorage.getItem("FName");
    const UserAvatar = sessionStorage.getItem("CurrentAvatar");
    if (UserName) setUserName(UserName);
    try {
      if (UserAvatar) setImageSrc(UserAvatar);
    } catch (error) {
      console.error("Error loading image:", error);
    }

    document.body.classList.add("StudyRoom-background");

    return () => {
      $(".AllPurchases").off("click", handleClick);
      document.body.classList.remove("StudyRoom-background");
    };
  }, [apiUrl]);

  return (
    <form>
      {loading && <Loading />}

      <div id="main_top_container">
        <Header />
                                        <a
          href="#bottom"
          className="back-to-bottom"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = (container as any).scrollHeight;
              (document.body as any).scrollTop = document.body.scrollHeight;
            }, 400);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }
          }}
          aria-label="Back to bottom"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToBottom ? 1 : 0,
            transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToBottom ? 'auto' : 'none',
            position: 'fixed',
            left: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',

       
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Bottom
        </a>

        <a
          href="#top"
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = 0;
              (document.body as any).scrollTop = 0;
            }, 300);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }
          }}
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToTop ? 1 : 0,
            transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToTop ? 'auto' : 'none',
            position: 'fixed',
            right: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Top
        </a>
        <Section />
        <div id="mi_banner" className="subject_banner">
          <div id="mi_banner_text_img"></div>
        </div>
      </div>

      <div id="mi_page_btn_container">
        <div id="mi_page_btn_store" className="mi_page_btn">
          <a href="/STUDENT/MSR/MyStore">Store</a>
        </div>
        <div id="mi_page_btn_avatars" className="mi_page_btn">
          <a href="/STUDENT/MSR/MyIncentives">Avatars</a>
        </div>
        <div id="mi_page_btn_comp" className="mi_page_btn">
          <a href="/STUDENT/MSR/MyCompsCurrent">Comps</a>
        </div>
        <div id="mi_page_btn_purchase" className="mi_page_btn mi_page_btn_last mi_page_btn_selected">
          <a href="/STUDENT/MSR/AllPurchases">Purchases</a>
        </div>
      </div>

      <div id="mi_page_purchases" className="contents section_container mi_page_bg">
        <div id="mi_purchases_container" className="section_div">
          <div id="mi_purchases_table_container_01" className="mi_purchases_table_container">
            <div id="mi_purchases_table_row_top_00" className="mi_purchases_table_row mi_purchases_table_row_top">
              <div className="mi_purchases_table_row_image" style={{backgroundSize:'contain'}}></div>
              <div className="mi_purchases_table_row_type mi_purchases_table_row_text mi_purchases_table_row_text_bold">
                <p>Type</p>
              </div>
              <div className="mi_purchases_table_row_date mi_purchases_table_row_text mi_purchases_table_row_text_bold">
                <p>Date</p>
              </div>
              <div className="mi_purchases_table_row_item mi_purchases_table_row_text mi_purchases_table_row_text_bold">
                <p>Items</p>
              </div>
              <div className="mi_purchases_table_row_points mi_purchases_table_row_text mi_purchases_table_row_text_bold">
                <p>Points</p>
              </div>
              <div className="mi_purchases_table_row_status mi_purchases_table_row_text mi_purchases_table_row_text_bold">
                <p>Status</p>
              </div>
            </div>

            {Array.isArray(purchases) && purchases.length > 0 ? (
              purchases.map((purchase, index) => (
                <div className="mi_purchases_table_row mi_purchases_table_row_expand" key={index}>
                  <div
                    className="mi_purchases_table_row_image"
                    style={{ backgroundImage: `url(${purchase.ImageUrl || ""})`,backgroundSize:'contain' }}
                  ></div>
                  <div className="mi_purchases_table_row_type">
                    <p>{purchase.Type || "Avatar"}</p>
                  </div>
                  <div className="mi_purchases_table_row_date">
                    <p>{purchase.PurchaseDate || (purchase.PurchasedOn || "").toString().substring(0, 10)}</p>
                  </div>
                  <div className="mi_purchases_table_row_item">
                    <p>{purchase.ItemName || purchase.Title || purchase.AvatarTitle || ""}</p>
                  </div>
                  <div className="mi_purchases_table_row_points">
                    <p>{purchase.Points ?? purchase.PointsUsed ?? ""}</p>
                  </div>
                  <div className="mi_purchases_table_row_status">
                    <p>{purchase.Status || `${purchase.Type || "Item"} purchased`}</p>
                  </div>
                </div>
              ))
            ) : (
              !loading && <p style={{ textAlign: "center", padding: "10px" }}></p>
            )}

            <div id="mi_purchases_table_row_00" className="mi_purchases_table_row"></div>
          </div>
          <div className="subject_bottom_gap"></div>
        </div>
      </div>
    </form>
  );
};

export default AllPurchases;
